import request from '@/utils/request'

// 生产环境api路径


// 检测是否被认领
export function checkexpertid (data) {
  return request({
    url: '/old/api/checkexpertid',
    method: 'POST',
    data
  })
}
// 获取专家信息
export function getOrgArray (data) {
  return request({
    url: '/old/api/queryNameOrgArray',
    method: 'POST',
    data
  })
}
// 获取多条柱状图数据
export function getQueryAcademicStats (data) {
  return request({
    url: '/old/api/queryAcademicStats',
    method: 'POST',
    data
  })
}

// 获取成果列表数据
export function getQueryResourcesNew (data) {
  return request({
    url: '/old/getResourcesNew',
    method: 'POST',
    data
  })
}

// 学科分布
export function getQueryResources (data) {
  return request({
    url: '/old/api/queryResources',
    method: 'POST',
    data
  })
}

// 研究主题
export function getYearKey (data) {
  return request({
    data: data,
    url: '/old/yearKeywords',
    method: 'post'
  })
}

// 认领
export function setClaim (data) {
  return request({
    data: data,
    url: '/old/api/UserExpertManagement',
    method: 'post'
  })
}

// 获取简历
export function getSum (data) {
  return request({
    data: data,
    url: '/api/queryExpertSummary?v=' + Math.random(),
    method: 'post'
  })
}
// 获取用户认领专家信息
export function getUser (data) {
  return request({
    data: data,
    url: '/old/api/UserExpertManagement/Query',
    method: 'post'
  })
}

// 未认领专家成果列表
export function getForkid (data) {
  return request({
    data: data,
    method: 'post',
    url: '/old/getresourceforkid'
  })
}

// 中文论文摘要
export function getPaperAbstract (data) {
  return request({
    data: data,
    url: '/old/getPaperAbstract',
    method: 'post'
  })
}

// 是否院士
export function isAcademician (data) {
  return request({
    data: data,
    url: '/old/checkyuanshi',
    method: 'post'
  })
}

// 是否显示跳转专家路径
export function isPath (data) {
  return request({
    data: data,
    url: '/old/checkNameForSearch',
    method: 'post'
  })
}
// 获取学校信息
export function getOrg (data) {
  return request({
    data: data,
    url: '/old/queryOrganization',
    method: 'post'
  })
}

// 开发环境api路径

// 获取专家信息
// export function getOrgArray (data) {
//   return request({
//     url: '/test/api/queryNameOrgArray',
//     method: 'POST',
//     data
//   })
// }

// // 获取多条柱状图数据
// export function getQueryAcademicStats (data) {
//   return request({
//     url: '/test/api/queryAcademicStats',
//     method: 'POST',
//     data
//   })
// }
// // 获取成果列表数据
// export function getQueryResourcesNew (data) {
//   return request({
//     url: '/test/getResourcesNew',
//     method: 'POST',
//     data
//   })
// }

// // 学科分布
// export function getQueryResources (data) {
//   return request({
//     url: '/test/api/queryResources',
//     method: 'POST',
//     data
//   })
// }

// // 研究主题
// export function getYearKey (data) {
//   return request({
//     data: data,
//     url: '/test/yearKeywords',
//     method: 'post'
//   })
// }

// // 认领
// export function setClaim (data) {
//   return request({
//     data: data,
//     url: 'test/api/UserExpertManagement',
//     method: 'post'
//   })
// }

// // 获取简历
// export function getSum (data) {
//   return request({
//     data: data,
//     url: '/test/api/queryExpertSummary?v=' + Math.random(),
//     method: 'post'
//   })
// }

// // 获取用户认领专家信息
// export function getUser (data) {
//   return request({
//     params: data,
//     url: '/test/api/UserExpertManagement/Query',
//     method: 'post'
//   })
// }
// // 未认领专家成果列表
// export function getForkid (data) {
//   return request({
//     data: data,
//     method: 'post',
//     url: 'test/getresourceforkid'
//   })
// }

// // 中文论文摘要
// export function getPaperAbstract (data) {
//   return request({
//     data: data,
//     url: 'test/getPaperAbstract',
//     method: 'post'
//   })
// }

// // 是否院士
// export function isAcademician (data) {
//   return request({
//     data: data,
//     url: 'test/checkyuanshi',
//     method: 'post'
//   })
// }

// // 是否显示跳转专家路径
// export function isPath (data) {
//   return request({
//     data: data,
//     url: 'test/checkNameForSearch',
//     method: 'post'
//   })
// }
// export function getOrg (data) {
//     return request({
//       data: data,
//       url: 'test/queryOrganization',
//       method: 'post'
//     })
//   }



// WEBPACK FOOTER //
// ./src/api/detail.js